<template>
  <div class="onboarding-review">
    <Nav />
    <div class="pt-5 mt-5 onboarding-width">
      <div class="mt-5 p-4 border add-rounded mx-3 mx-md-5">
        <div class="control-width mx-auto">
          <h4 class="mb-4 font-weight-bold text-capitalize kova-text">
            tell us about your project
          </h4>
          <h6 class="mb-3 font-weight-bold">What stage is your project?</h6>
          <div class="container-fluid px-0 px-md-4 mb-5">
            <div class="row my-5">
              <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
                <div
                  class="border stage-box d-flex align-items-center mx-auto"
                  @click="clickedNew"
                >
                  <h6 class="kova-text font-weight-bolder mx-auto">
                    New Project
                  </h6>
                  <font-awesome-icon
                    icon="check-circle"
                    class="checked"
                    v-if="newProject"
                  ></font-awesome-icon>
                </div>
              </div>
              <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
                <div
                  class="border stage-box d-flex align-items-center mx-auto"
                  @click="clickedOngoing"
                >
                  <h6 class="kova-text font-weight-bolder mx-auto">
                    Ongoing Project
                  </h6>
                  <font-awesome-icon
                    icon="check-circle"
                    class="checked"
                    v-if="onGoing"
                  ></font-awesome-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bold kova-text">
            Provide project description below
          </h4>
          <h6 class="mb-3 font-weight-bold text-left mt-4">Project name</h6>

          <a-input
            size="large"
            placeholder="e.g. Build me web application"
            class="mx-auto mb-3"
          />
          <a-textarea
            size="large"
            placeholder="Project description"
            class="mx-auto mt-2"
            :autosize="{ minRows: 4, maxRows: 8 }"
          />
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bolder kova-text">
            What Tech-stack requirement do you want your dev to have?
          </h4>
          <a-select
            mode="multiple"
            class="w-100 mt-4 mb-5"
            @change="handleChange"
            size="large"
            placeholder="What skills are required"
          >
            <a-select-option v-for="stack in stacks" :key="stack">{{
              stack
            }}</a-select-option>
          </a-select>
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-4 font-weight-bold kova-text">
            Do you have product specifications ready?
          </h4>
          <div class="text-left">
            <label class="checkbox-label mb-3">
              <input type="checkbox" />
              <span class="checkbox-custom rectangular"></span
              ><span class="pl-4 ml-2 mb-3 input-title"
                >System/Product requirement specifications (SRS) document</span
              > </label
            ><br />
            <label class="checkbox-label mb-3">
              <input type="checkbox" />
              <span class="checkbox-custom rectangular"></span
              ><span class="pl-4 ml-2 pb-2 input-title"
                >Wireframes</span
              > </label
            ><br />
            <label class="checkbox-label mb-3">
              <input type="checkbox" />
              <span class="checkbox-custom rectangular"></span
              ><span class="pl-4 ml-2 pb-2 input-title"
                >UI/UX prototype</span
              > </label
            ><br />
            <label class="checkbox-label mb-3">
              <input type="checkbox" />
              <span class="checkbox-custom rectangular"></span
              ><span class="pl-4 ml-2 pb-2 input-title"
                >No,only have idea what I want to build</span
              > </label
            ><br />

            <a-upload-dragger
              name="file"
              :multiple="true"
              action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              @change="handleChange"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="upload" />
              </p>
              <p class="ant-upload-text">
                Click or drag file to this area to upload
              </p>
              <p class="ant-upload-hint">
                <!-- Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                            band files -->
              </p>
            </a-upload-dragger>
          </div>
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bold kova-text">
            How many hours of commitment will you require from your developer?
          </h4>
          <div class="text-left">
            <label for="opt1" class="radio text-left">
              <input type="radio" name="rdo" id="opt1" class="hidden" />
              <span class="label"></span>40 or more hrs/week (Full time) </label
            ><br />

            <label for="opt2" class="radio text-left">
              <input type="radio" name="rdo" id="opt2" class="hidden" />
              <span class="label"></span>Less than 40 hrs/week (Part time) </label
            ><br />

            <label for="opt3" class="radio text-left">
              <input type="radio" name="rdo" id="opt3" class="hidden" />
              <span class="label"></span>Hourly </label
            ><br />

            <label for="opt4" class="radio text-left">
              <input type="radio" name="rdo" id="opt4" class="hidden" />
              <span class="label"></span>Don't know yet </label
            ><br />
          </div>
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bold kova-text">Select Job Type</h4>
          <div class="text-left">
            <label for="job1" class="radio text-left">
              <input type="radio" name="rdo1" id="job1" class="hidden" />
              <span class="label"></span>Remote Job </label
            ><br />

            <label for="job2" class="radio text-left">
              <input type="radio" name="rdo1" id="job2" class="hidden" />
              <span class="label"></span>Office Job </label
            ><br />

            <label for="job3" class="radio text-left">
              <input type="radio" name="rdo1" id="job3" class="hidden" />
              <span class="label"></span>Crowdsource Project </label
            ><br />
          </div>
        </div>
        <hr />

        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bold kova-text">
            How long do you need the developer to work on your project?
          </h4>
          <div class="text-left">
            <label for="dur1" class="radio text-left">
              <input
                type="radio"
                name="rdo2"
                id="dur1"
                class="hidden"
                value="weeks"
                v-model="duration"
              />
              <span class="label"></span>1 to 4 weeks </label
            ><br />

            <label for="dur2" class="radio text-left">
              <input
                type="radio"
                name="rdo2"
                id="dur2"
                class="hidden"
                value="months"
                v-model="duration"
              />
              <span class="label"></span>1 to 3 months </label
            ><br />

            <label for="dur3" class="radio text-left">
              <input
                type="radio"
                name="rdo2"
                id="dur3"
                class="hidden"
                value="moremonths"
                v-model="duration"
              />
              <span class="label"></span>3 to 6 months </label
            ><br />

            <label for="dur4" class="radio text-left">
              <input
                type="radio"
                name="rdo2"
                id="dur4"
                class="hidden"
                value="manymonths"
                v-model="duration"
              />
              <span class="label"></span>Longer than 6 months </label
            ><br />

            <label for="dur5" class="radio text-left">
              <input
                type="radio"
                name="rdo2"
                id="dur5"
                class="hidden"
                value="hours"
                v-model="duration"
              />
              <span class="label"></span>Few hours
            </label>
            <div class="ml-5" v-if="showInput">
              How many hours?
              <input type="number" class="input" placeholder="6" />
            </div>
            <br />

            <label for="dur6" class="radio text-left">
              <input
                type="radio"
                name="rdo2"
                id="dur6"
                class="hidden"
                value="not-certain"
                v-model="duration"
              />
              <span class="label"></span>Don't know yet </label
            ><br />
          </div>
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bold kova-text">
            How many developers are you hiring?
          </h4>
          <div class="text-left">
            <label for="dev1" class="radio text-left">
              <input
                type="radio"
                name="rdo3"
                id="dev1"
                class="hidden"
                value="weeks"
                v-model="duration"
              />
              <span class="label"></span>One Developer </label
            ><br />

            <label for="dev2" class="radio text-left">
              <input
                type="radio"
                name="rdo3"
                id="dev2"
                class="hidden"
                value="months"
                v-model="duration"
              />
              <span class="label"></span>More than one </label
            ><br />

            <label for="dev3" class="radio text-left">
              <input
                type="radio"
                name="rdo3"
                id="dev3"
                class="hidden"
                value="moremonths"
                v-model="duration"
              />
              <span class="label"></span>Don't know yet </label
            ><br />
          </div>
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bold kova-text">
            Select an hourly rate that fits your budget. At TalentAlt, we have
            developers vetted and place them on the level of expertise that
            matches their skills
          </h4>
          <div class="text-left">
            <label for="bud1" class="radio text-left">
              <input
                type="radio"
                name="rdo4"
                id="bud1"
                class="hidden"
                value="devone"
                v-model="payment"
              />
              <span class="label"></span>$10 - $17/hr (Junior) </label
            ><br />

            <label for="bud2" class="radio text-left">
              <input
                type="radio"
                name="rdo4"
                id="bud2"
                class="hidden"
                value="devtwo"
                v-model="duration"
              />
              <span class="label"></span>$15 - $30/hr (Intermediate) </label
            ><br />

            <label for="bud3" class="radio text-left">
              <input
                type="radio"
                name="rdo4"
                id="bud3"
                class="hidden"
                value="devthree"
                v-model="duration"
              />
              <span class="label"></span>$25- $40/hr (Senior) </label
            ><br />

            <label for="bud4" class="radio text-left">
              <input
                type="radio"
                name="rdo4"
                id="bud4"
                class="hidden"
                value="not-certain"
                v-model="duration"
              />
              <span class="label"></span>Fixed price per month?
            </label>
            <div class="ml-5" v-if="showInput">
              State it: <input type="number" class="input" placeholder="1000" />
            </div>
          </div>
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bold kova-text">
            Let's go ahead and make a job post for you
          </h4>
          <h6 class="font-weight-bold mb-4 text-left">
            Write a detailed task description of what developer(s) will build
          </h6>
          <a-input
            size="large"
            class="m-auto w-100"
            placeholder="Job description here"
          />
          <h6 class="font-weight-bold mb-4 mt-5 text-left">
            select skill(s) you require from your developer
          </h6>

          <div class="d-flex flex-wrap text-left">
            <div
              class="pl-4 py-1"
              style="min-width: 200px"
              v-for="skill in skills"
              :key="skill"
            >
              <label class="checkbox-label mb-3">
                <input type="checkbox" :value="skill" v-model="devSkills" />
                <span class="checkbox-custom rectangular"></span
                ><span class="mb-3 input-title ml-4 pl-2">{{ skill }}</span>
              </label>
            </div>
          </div>
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bold kova-text">Add Location</h4>
          <a-select
            mode="multiple"
            class="w-100 mt-4"
            size="large"
            placeholder="Please select your Country"
          >
            <a-select-option v-for="(item, index) in countries" :key="index">{{
              item.name
            }}</a-select-option>
          </a-select>
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bold kova-text">Language</h4>
          <a-select
            mode="multiple"
            class="w-100 mt-4"
            size="large"
            placeholder="Please select your Language"
          >
            <a-select-option v-for="(item, index) in languages" :key="index">{{
              item
            }}</a-select-option>
          </a-select>
        </div>
        <hr />
        <div class="control-width mx-auto">
          <h4 class="mb-3 font-weight-bold kova-text">Visibility</h4>
          <div class="d-flex flex-wrap text-left">
            <div
              class="pl-4 py-1"
              style="min-width: 200px"
              v-for="visibility in visibilities"
              :key="visibility"
            >
              <label class="checkbox-label mb-3">
                <input
                  type="checkbox"
                  :value="visibility"
                  v-model="visibilityStatus"
                />
                <span class="checkbox-custom rectangular"></span
                ><span class="mb-3 input-title ml-4 pl-2">{{
                  visibility
                }}</span>
              </label>
            </div>
          </div>
          <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
            <div class="row">
              <div class="col text-left">
                <button
                  class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                  v-on:click="goBack"
                >
                  Cancel
                </button>
              </div>
              <div class="col text-right">
                <button
                  class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded"
                  v-on:click="next"
                >
                  Post My Job
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="control-width mx-auto">
                </div>
                <hr /> -->
      </div>

      <div class="mt-2 mb-5 px-3 mx-3 mx-md-5 row">
        <div>
          <label class="checkbox-label">
            <input type="checkbox" />
            <span class="checkbox-custom rectangular"></span
            ><span class="mb-3 input-title ml-4 pl-2"></span>
          </label>
        </div>
        <div>
          <p class="text-left">
            By registering you conﬁrm that you accept the
            <span class="font-weight-bolder">Terms and Conditions</span> and
            <span class="font-weight-bolder">Privacy Policy</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';

export default {
  name: 'onboarding-review',
  components: {
    Nav,
  },
  data() {
    return {
      newProject: false,
      isNew: false,
      onGoing: false,
      isOngoing: false,
      stacks: [
        'PHP',
        'Nodejs',
        'Django',
        'Flask',
        'Laravel',
        'Java',
        'C#',
        'C++',
        '.NET',
        'Ruby',
        'Scala',
        'Perl',
        'Symfony',
        'Spring',
        'JSF',
        'Others',
      ],
      countries: [],
      duration: '',
      showInput: false,
      skills: [
        'Android',
        'IOS',
        'CyberSecurity',
        'Data Engineering',
        'eCommerce',
        'Web Application',
        'Front-end',
        'Back-end',
        'UI/UX',
        'Artificial Intelligence',
        'Blockchain',
        'Integration',
        'Project management',
        'DApps',
        'DevOps',
      ],
      languages: ['English', 'French'],
      visibilityStatus: [],
      visibilities: [
        'Visible to everyone',
        'Only Senior Developers',
        'Only Intermediate Developers',
        'Only Junior Developers',
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      this.$router.push('payment-budget');
    },
    skip() {
      this.$router.push('onboarding/description');
    },
    clickedNew() {
      this.newProject = true;
      this.isNew = true;
      this.onGoing = false;
      this.isOngoing = false;
    },
    clickedOngoing() {
      this.onGoing = true;
      this.isOngoing = true;
      this.newProject = false;
      this.isNew = false;
    },
  },
  mounted() {
    this.$http({
      method: 'GET',
      url: 'https://ajayakv-rest-countries-v1.p.rapidapi.com/rest/v1/all',
      headers: {
        'x-rapidapi-host': 'ajayakv-rest-countries-v1.p.rapidapi.com',
        'x-rapidapi-key': '6ca124e468msh22c5cc821adbce1p14a23ejsn2364b404d00d',
      },
    }).then((response) => {
      this.countries = response.data;
      // console.log(response.data)
    });
  },
};
</script>

<style scoped>
span,
p,
li {
  font-size: 12px;
}
.onboarding-width {
  max-width: 1200px;
  margin: auto;
}

.control-width {
  width: 600px;
}
.stage-box {
  height: 90px;
  width: 180px;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
.stage-box:hover {
  background-color: #f1f1f1;
}
.checked {
  position: absolute;
  left: 190px;
  font-size: 35px;
  bottom: 45px;
  color: #4bb38e;
}
.input-title {
  font-size: 15px;
}
@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
  .stage-box {
    height: 75px;
    width: 140px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }
  .checked {
    position: absolute;
    left: 135px;
    font-size: 30px;
    bottom: 45px;
    color: #4bb38e;
  }
}
</style>
